import { Mutation } from '@varo/graphql-schema-types';
import { isToggleAddDebitCardVisibilityError } from 'features/advance/helpers/Advance.helpers';
import ToggleShowAddDebitCardBottomSheet from 'services/graphql/mutations/Advance/ToggleShowAddDebitCardBottomSheet';
import { useMutation } from 'urql';

const useToggleShowAddDebitBottomSheet = () => {
  const [
    { data: toggleData, fetching: toggleFetching, error: toggleError },
    executeToggleAddDebitCardVisibilityMutation,
  ] = useMutation<Mutation>(ToggleShowAddDebitCardBottomSheet);

  const error = isToggleAddDebitCardVisibilityError(
    toggleData?.toggleAddDebitCardVisibility,
  )
    ? toggleData
    : undefined;

  const hasError = Boolean(error || toggleError);
  return {
    loading: toggleFetching,
    hasError,
    execute: executeToggleAddDebitCardVisibilityMutation,
  };
};

export default useToggleShowAddDebitBottomSheet;
